import React, {useEffect, useState} from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {userManager} from '@app/utils/oidc';
import {isTokenValid} from '@app/utils/helper';

// const PrivateRoute = ({children, ...rest}) => {
//     const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
//     return (
//         <Route
//             {...rest}
//             render={({location}) =>
//                 isLoggedIn ? (
//                     children
//                 ) : (
//                     <Redirect
//                         to={{
//                             pathname: '/loginsso',
//                             state: {from: location}
//                         }}
//                     />
//                 )
//             }
//         />
//     );
// };

const PrivateRoute = ({children, ...rest}) => {
    // const isLoggedIn = useSelector(s => s.auth.isLoggedIn);
    const [isLoggedIn, setIsLoggedIn] = useState(null);

    useEffect(() => {
        isTokenValid().then(setIsLoggedIn);
    }, []);

    if (isLoggedIn === null) return null;

    return (
        <Route
            {...rest}
            render={({location}) =>
                isLoggedIn ? (
                    children
                ) : location.pathname !== '/loginsso' ? (
                    <Redirect
                        to={{pathname: '/loginsso', state: {from: location}}}
                    />
                ) : null
            }
        />
    );
};

export default PrivateRoute;
